/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { VisitTakenPayloadSideEffectType } from "./VisitTakenPayloadSideEffectType";

export interface VisitTakenPayload {
  side_effect_type: VisitTakenPayloadSideEffectType;
  taken_conversation_id: string;
}
